import { render } from "./ExpertStatistics.vue?vue&type=template&id=3e5471b4"
import script from "./ExpertStatistics.vue?vue&type=script&lang=js"
export * from "./ExpertStatistics.vue?vue&type=script&lang=js"

import "./ExpertStatistics.vue?vue&type=style&index=0&id=3e5471b4&lang=css"
script.render = render

export default script